import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex max-w-content flex-col items-center px-4 py-24 text-center md:px-6">
        <p className="font-heading text-6xl font-black text-background-300 md:text-8xl">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这条线索暂时不存在</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的页面可能已被更正、合并或移除。可以回到首页，或者直接进入爆料库继续浏览。
        </p>
        <p className="mt-2 rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line text-base" aria-hidden="true"></i>
            返回首页
          </Link>
          <Link
            to="/stories"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 px-5 py-2.5 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-stack-line text-base" aria-hidden="true"></i>
            进入爆料库
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}